<template>
  <v-switch class="mt-0" :disabled="allow" :readonly="readonly" :label="label"
    @change="change" :input-value="value" :loading="loading">
    <template v-slot:prepend>
      <v-icon :color="value ? iconColor : 'grey'">mdi-{{ icon }}</v-icon>
      <v-icon color="red" small v-if="allow">mdi-lock</v-icon>
      <v-tooltip bottom v-if="readonly">
        <template v-slot:activator="{ on }">
          <v-icon color="red" v-on="on" small>mdi-pencil-off</v-icon>
        </template>
        <span>{{ $t('perms.readOnly') }}</span>
      </v-tooltip>
    </template>
    <template v-slot:append>
      <cp-help :i18n="help" />
    </template>
  </v-switch>
</template>

<script>
export default {
  name: 'settings-flags-switch',
  props: {
    value: Boolean,
    allow: Boolean,
    readonly: Boolean,
    label: String,
    icon: String,
    help: String,
    loading: Boolean,
    iconColor: {
      type: String,
      default: 'green'
    }
  },
  methods: {
    change (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped></style>
